<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Code" prop="code">
          <a-input ref="code" v-model="form.code" placeholder="Enter text..." />
        </a-form-model-item>
        <a-form-model-item label="Name">
          <a-input v-model="form.name" placeholder="Enter text..." />
        </a-form-model-item>
        <a-form-model-item label="Department / Phòng ban" prop="departmentIds">
          <SelectDepartment
            v-model="form.departmentIds"
            :selectProps="{
              value: form.departmentIds || undefined,
              mode: 'multiple',
              placeholder: 'Department',
            }"
          />
        </a-form-model-item>
      </a-form-model>
      <a-divider orientation="left">
        INFORMATION
      </a-divider>
      <a-descriptions :column="1">
        <a-descriptions-item label="Author">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Created At">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Updated At">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Confirm action?"
          ok-text="Delete"
          cancel-text="No"
          @confirm="onDeletedDepartmentGroup"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Delete
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close">
          Close
        </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Update
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import query from "../constant/query";
// components
import SelectDepartment from "@/components/common/department/select";

export default {
  components: { SelectDepartment },

  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idDepartmentGroup: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      loadingBtn: false,
      rules: {
        code: [
          {
            required: true,
            message: "Required / Code không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    setFormItem(nameForm, value) {
      this.$set(this.form, nameForm, value);
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdatedDepartmentGroup();
        } else {
          return false;
        }
      });
    },
    onUpdatedDepartmentGroup() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateDepartmentGroup,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Update success!",
          });
          this.loadingBtn = false;
          if (data?.updateDepartmentGroup?.id) {
            this.refreshAfterUpdated(data.updateDepartmentGroup);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Update error!",
          });
          console.error("Cập nhật khách hàng không thành công", err);
        });
    },
    onGetDepartmentGroup() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getDepartmentGroup,
          variables: { id: this.idDepartmentGroup },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.getDepartmentGroup?.id) {
            this.departmentGroup = { ...data.getDepartmentGroup };
            this.form = {
              ...data.getDepartmentGroup,
              departmentIds: data.getDepartmentGroup.departments.map(
                (department) => department.id
              ),
            };
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get info error!",
          });
          console.error("Lấy chi tiết không thành công", err);
        });
    },
    onDeletedDepartmentGroup() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteDepartmentGroup,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Success",
              description: "Delete success!",
            });
            this.loadingBtn = false;
            if (data?.deleteDepartmentGroup?.id) {
              this.refreshAfterDeleted(data.deleteDepartmentGroup);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Error",
              description: "Delete error!",
            });
            console.error("Xóa khách hàng không thành công", err);
          });
      }
    },
  },
  created() {
    this.onGetDepartmentGroup();
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
